import { cn } from "@gettactic/helpers";
import { isTacticAppWebView } from "@gettactic/helpers/src/isTacticAppWebView";
import React from "react";

export interface MobileContentLayoutContainerProps {
  className?: string;
  cleanWrapper?: boolean;
}

export const MobileContentLayoutContainer: React.FC<
  React.PropsWithChildren<MobileContentLayoutContainerProps>
> = ({ children, className, cleanWrapper }) => {
  const isMobileApp = isTacticAppWebView();

  return (
    <div
      className={cn(
        "bg-neutral-50",
        !cleanWrapper ? "relative flex w-screen flex-col gap-4 px-2" : "",
        className
      )}
    >
      {/* Top gap to prevent content hide under the header */}
      <div className={"h-2"} />
      {children}
      {/* Bottom gap to prevent content hide under the bottom nav bar */}
      {isMobileApp ? <div className={"h-20"} /> : <div className={"h-14"} />}
    </div>
  );
};
